import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";
import { memo } from "react";

const CloseIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 25"
      {...otherProps}
      sx={{ fontSize: "inherit", ...sx }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.41999 5.70247C6.20672 5.50466 5.92465 5.39697 5.6332 5.40209C5.34175 5.40721 5.06367 5.52474 4.85755 5.72991C4.65143 5.93509 4.53337 6.21189 4.52822 6.50201C4.52308 6.79212 4.63127 7.0729 4.82999 7.28518L10.41 12.8396L4.82999 18.394C4.71946 18.4966 4.6308 18.6202 4.56932 18.7576C4.50783 18.8949 4.47476 19.0432 4.4721 19.1936C4.46943 19.3439 4.49722 19.4933 4.5538 19.6327C4.61038 19.7722 4.6946 19.8988 4.80143 20.0052C4.90826 20.1115 5.03551 20.1954 5.17559 20.2517C5.31567 20.308 5.46572 20.3357 5.61677 20.333C5.76782 20.3304 5.91679 20.2974 6.05479 20.2362C6.19279 20.175 6.31699 20.0868 6.41999 19.9768L12 14.4223L17.58 19.9768C17.683 20.0868 17.8072 20.175 17.9452 20.2362C18.0832 20.2974 18.2321 20.3304 18.3832 20.333C18.5343 20.3357 18.6843 20.308 18.8244 20.2517C18.9645 20.1954 19.0917 20.1115 19.1985 20.0052C19.3054 19.8988 19.3896 19.7722 19.4462 19.6327C19.5028 19.4933 19.5305 19.3439 19.5279 19.1936C19.5252 19.0432 19.4921 18.8949 19.4307 18.7576C19.3692 18.6202 19.2805 18.4966 19.17 18.394L13.59 12.8396L19.17 7.28518C19.3687 7.0729 19.4769 6.79212 19.4717 6.50201C19.4666 6.21189 19.3485 5.93509 19.1424 5.72991C18.9363 5.52474 18.6582 5.40721 18.3668 5.40209C18.0753 5.39697 17.7932 5.50466 17.58 5.70247L12 11.2569L6.41999 5.70247Z"
        fill="#currentColor"
      />
    </SvgIcon>
  );
};

export default memo(CloseIcon);
